import React from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";

const Header = ({ activeSection }) => {
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="p-4 py-8 flex flex-col lg:justify-between lg:min-h-[calc(100vh-192px)] ">
        <div>
          <h1 className="md:text-5xl text-4xl font-bold mb-4 orbitron">
            Jay Kolawala
          </h1>
          <h2 className="mt-3 text-xl text-[#e2e8f0] orbitron">
            Fullstack Developer
          </h2>
          <p className="mt-4 max-w-xs text-[#94a3b8]">
            I build accessible, pixel-perfect digital experiences for the web.
          </p>

          {/* Navigation List */}
          <ul className="space-y-4 mt-6 lg:block">
            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("home")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "home" ? "!w-20 bg-white" : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#home"
                className={`group-hover:text-white ${
                  activeSection === "home"
                    ? "text-white philosopher-5"
                    : "text-gray-400 philosopher-6"
                }`}
              >
                About
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("education")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "education"
                    ? "!w-20 bg-white"
                    : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#education"
                className={`group-hover:text-white ${
                  activeSection === "education"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Education
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("experience")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "experience"
                    ? "!w-20 bg-white"
                    : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#experience"
                className={`group-hover:text-white ${
                  activeSection === "experience"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Experience
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("skills")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "skills" ? "!w-20 bg-white" : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#skills"
                className={`group-hover:text-white ${
                  activeSection === "skills"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Skills
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("projects")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "projects"
                    ? "!w-20 bg-white"
                    : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#projects"
                className={`group-hover:text-white ${
                  activeSection === "projects"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Projects
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("services")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "services"
                    ? "!w-20 bg-white"
                    : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#services"
                className={`group-hover:text-white ${
                  activeSection === "services"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Services
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("testimonials")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "testimonials"
                    ? "!w-20 bg-white"
                    : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#testimonials"
                className={`group-hover:text-white ${
                  activeSection === "testimonials"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Testimonials
              </Link>
            </li>

            <li
              className="flex gap-2 group items-center w-fit cursor-pointer"
              onClick={() => handleScroll("hobbies")}
            >
              <div
                className={`h-0.5 w-5 bg-gray-400 rounded-full transition-all group-hover:w-20 group-hover:bg-white ${
                  activeSection === "hobbies" ? "!w-20 bg-white" : "bg-gray-400"
                }`}
              ></div>
              <Link
                to="#hobbies"
                className={`group-hover:text-white ${
                  activeSection === "hobbies"
                    ? "text-white philosopher-6"
                    : "text-gray-400 philosopher-5"
                }`}
              >
                Hobbies & Interests
              </Link>
            </li>
          </ul>
        </div>

        {/* Social Icons */}
        <div className="flex justify-between mt-4 items-start lg:pr-40">
          <div className="flex space-x-6 text-[#94a3b8] text-2xl">
            <a
              href="https://github.com/jaykolawala"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="hover:text-white transition-transform transform hover:scale-110"
            >
              <FaGithub />
            </a>
            <a
              href="https://linkedin.com/in/jaykolawala"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="hover:text-white transition-transform transform hover:scale-110"
            >
              <FaLinkedin />
            </a>
            <a
              href="mailto:jskolawala@gmail.com"
              aria-label="Email"
              className="hover:text-white transition-transform transform hover:scale-110"
            >
              <FaEnvelope />
            </a>
            <a
              href="tel:+919426631080"
              aria-label="Phone"
              className="hover:text-white transition-transform transform hover:scale-110"
            >
              <FaPhone />
            </a>
          </div>
        </div>

        <div className="mt-2">
          <a
            href="/assets/JayKolawala–Resume.pdf"
            download="JayKolawala–Resume.pdf"
            className="flex w-fit group bg-gradient-to-r from-purple-500 to-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:from-purple-600 hover:to-blue-600 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <span className="flex items-center space-x-2 philosopher-6">
              <span>Download Resume</span>
            </span>
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
